import { IconSize } from '../../Icons/IconWrap';
import { ButtonSize } from '../types';

export default function useIconSizeForButtonSize(buttonSize: ButtonSize) {
  switch (buttonSize) {
    case 'small':
      return IconSize.SMALLER;
    case 'medium':
      return IconSize.SMALLER;
    default:
      return IconSize.MEDIUM;
  }
}
